module.exports = __webpack_public_path__ + "static/img/exhibitImage3.0b90d37c.jpg";